import PropTypes from "prop-types";
import {
	FloatingFocusManager,
	FloatingOverlay,
	FloatingPortal,
	useClick,
	useDismiss,
	useFloating,
	useInteractions,
} from "@floating-ui/react";
import { useEffect, useState } from "react";

const floatingOverlayStyle = {
	background: "rgba(0, 0, 0, 0.8)",
	zIndex: 999999,
	display: "grid",
	placeItems: "center",
};

const Dialog = ({ isDialogOpen, onOpenChange = () => {}, children }) => {
	const [isOpen, setIsOpen] = useState(isDialogOpen);

	useEffect(() => {
		setIsOpen(isDialogOpen);
	}, [isDialogOpen]);

	const { refs, context } = useFloating({
		open: isOpen,
		onOpenChange: onOpenChange,
	});

	const click = useClick(context);
	const dismiss = useDismiss(context, {
		outsidePressEvent: "mousedown",
	});

	// Merge all the interactions into prop getters
	const { getFloatingProps } = useInteractions([click, dismiss]);

	return (
		<FloatingPortal>
			{isOpen && (
				<FloatingOverlay lockScroll style={floatingOverlayStyle}>
					<FloatingFocusManager context={context}>
						<div ref={refs.setFloating} {...getFloatingProps()}>
							{children}
						</div>
					</FloatingFocusManager>
				</FloatingOverlay>
			)}
		</FloatingPortal>
	);
};

Dialog.propTypes = {
	isDialogOpen: PropTypes.bool,
	onOpenChange: PropTypes.func,
};

export default Dialog;
